"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useCallback } from "react";

import { AlertsButton } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/alerts/alerts-button.container";
import { ALERTS_BUTTON_VARIANTS } from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/alerts/alerts-trigger-button.view";
import {
  VIEW_MODES,
  type ViewMode,
} from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/constants";
import ResultsHeaderView, {
  ResultsHeaderBackToListButton,
  ResultsHeaderProps,
  ResultsHeaderTotalResults,
} from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/results-header.view";
import { jobResultsHeaderTestIds } from "@/lib/data-test-ids/jobs.data-test-ids";

type ResultsHeaderClientProps = Omit<
  ResultsHeaderProps,
  "getModeUrl" | "initialContent" | "alertsSlot"
>;

export function ResultsHeaderContainer(props: ResultsHeaderClientProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isOnMapView = props.viewMode === VIEW_MODES.map;

  const getModeUrl = useCallback(
    (viewMode: ViewMode) => {
      const newParams = new URLSearchParams(searchParams);

      newParams.set("viewMode", viewMode);
      newParams.delete("page");

      return `${pathname}?${decodeURIComponent(newParams.toString())}`;
    },
    [searchParams, pathname],
  );

  return (
    <ResultsHeaderView
      {...props}
      getModeUrl={getModeUrl}
      alertsSlot={
        <AlertsButton
          variant={ALERTS_BUTTON_VARIANTS.full}
          testId={jobResultsHeaderTestIds.RESULT_HEADER_ALERTS_BUTTON}
        />
      }
      initialContent={
        isOnMapView ? (
          <ResultsHeaderBackToListButton getModeUrl={getModeUrl} />
        ) : (
          <ResultsHeaderTotalResults
            totalResults={props.totalResults}
            totalJobs={props.totalJobs}
          />
        )
      }
    />
  );
}
